/**
 * @typedef {string} Timestamp
 *
 * @typedef {{
 *   id: string,
 *   name: string,
 *   icon: string,
 *   typeId: number | string,
 *   createdAt: Timestamp,
 *   updatedAt: Timestamp,
 * }} Tag
 *
 */

import v3Generic from './v3-generic';
var _v3Generic = v3Generic('tags', 'sql'),
  search = _v3Generic.search,
  single = _v3Generic.single;
export default {
  /**
   *
   * @param {Object} [optional] $axios
   * @param {import('./v3-generic').SqlSearchOptions} options
   *
   * @returns {Promise<{data: Tag[]}>} Unresolved Promise from the API.
   */
  search: search,
  /**
   * Fetch a singular taxonomy by ID
   *
   * @param {Object} [optional] $axios Axios instance.
   * @param {String} id
   *
   * @returns {Promise<Tag>} Unresolved Promise from the API.
   */
  single: single
};